export default __webpack_public_path__ + "static/media/innov_texture_BG.d7d66b58.png";